








































import { Offer, ShipmentStatus } from '@/data/models/offer.model';
import { cloneDeep } from 'lodash';
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import RiscossioneList from './RiscossioneList.vue';

@Component({
	components: {
		RiscossioneList,
	},
})
export default class RiscossioneListModal extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: () => [] }) offers!: Offer[];

	@Ref('list') list!: RiscossioneList;

	disableAssignButton: boolean = true;
	selected: Offer[] = [];

	get buttonLabel(): string {
		return `${this.$t('assign-all-to')} ${(this.$t('user-type.delivery') as string).toLowerCase()}`;
	}
	
	constructor() {
		super();
	}

	@Watch('selected', { deep: true })
	onSelectedChange(selected: Offer[]) {
		this.disableAssignButton = selected.filter(row => row.shipmentstatus === ShipmentStatus.ASSIGNED).length > 0;
	}

	mounted() {
		const ids = this.offers.map(o => o.id);
		this.list.advancedSearch.addInFilter('id', ids);
		this.list.loadData();
	}

	onDataLoad(counter: number) {
		const countCond = counter > 0;
		const statusCond = this.list.rows.filter(row => row.shipmentstatus === ShipmentStatus.TO_BE_ASSIGNED).length > 0;
		if (countCond && statusCond) this.disableAssignButton = false;
	}

	assignToDelivery() {
		this.$emit('assign', { search: this.list.advancedSearch, selected: this.selected });
	}

	printEnvelopes() {
		this.$emit('print', cloneDeep(this.selected));
		this.selected = [];
	}

}
